import AccountContent from './account-home';
import AddressesSection from './addresses';
import CommunicationPreference from './communicationPreference';
import GeneralSection from './general';
import OrderDetail from './order-detail';
import OrdersHistorySection from './orders';
import SecuritySection from './security';
import Subscriptions from './subscriptions';
import Wallet from './wallet';
import Wishlist from './wishlist';
export {
  GeneralSection,
  SecuritySection,
  AddressesSection,
  OrdersHistorySection,
  AccountContent,
  Wallet,
  Subscriptions,
  Wishlist,
  CommunicationPreference,
  OrderDetail,
};
